import * as React from "react";
import { LayoutDashboard, Fingerprint, Image as ImageIcon, Share2, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
const solutions = [{
  title: "The Starter Kit",
  description: "Essential foundations for modern intimacy, curated by our wellness experts for those beginning their journey.",
  icon: LayoutDashboard,
  link: "/HomePage"
}, {
  title: "The Wellness Bundle",
  description: "A comprehensive collection of guides focusing on holistic health, emotional connection, and self-care.",
  icon: Fingerprint,
  link: "/HomePage"
}, {
  title: "The Pro Playbook",
  description: "Advanced editorial insights and deep-dives into the psychology of love, wellness, and modern relationships.",
  icon: ImageIcon,
  link: "/HomePage"
}, {
  title: "The VIP Guide",
  description: "Our most exclusive curation of premium advice, zodiac insights, and high-authority wellness strategies.",
  icon: Share2,
  link: "/HomePage"
}];
export default function OurSignatureSolutions() {
  return <section data-section-id="223689" id="the-arsenal" className="bg-background text-foreground py-24 px-6 md:px-12 lg:px-24">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16 md:mb-24">
          <h2 className="font-default text-4xl font-bold tracking-tight md:text-5xl lg:text-6xl text-foreground">
            The Arsenal
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4 lg:gap-12">
          {solutions.map((solution, i) => <Card key={i} data-index={i} className={`group relative flex min-h-[320px] flex-col rounded-xl border bg-card p-0 pt-8 transition-all duration-500 hover:shadow-xl ${solution.title === "The VIP Guide" ? "border-2 border-chart-2 shadow-md" : "border-border shadow-sm"}`}>
              {solution.title === "The VIP Guide" && <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-chart-2 text-white text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded-full">
                  Best Value
                </div>}
              
              <div className="px-6 pb-6 md:px-8 md:pb-8 flex flex-col h-full">
                <solution.icon className="size-8 text-primary transition-transform duration-500 group-hover:scale-110" strokeWidth={1.5} />
                
                <h3 className="font-default mt-12 mb-4 text-[24px] font-semibold leading-tight tracking-tight text-foreground">
                  {solution.title}
                </h3>
                
                <p className="font-sans text-muted-foreground text-base leading-relaxed">
                  {solution.description}
                </p>

                <div className="mt-auto pt-8 overflow-hidden">
                  <Link to={solution.link} className="inline-flex items-center gap-2 text-sm font-medium text-primary transition-all duration-500 hover:gap-3">
                    Explore <ArrowRight className="size-4" />
                  </Link>
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}